/**
 * Qualify UTC appointment values whose timezone designator was omitted when
 * PostgreSQL `timestamp without time zone` was serialized by the API.
 *
 * This helper is appointment-specific. Clinical birth timestamps are unzoned
 * wall-clock values and must not be passed through it.
 */
export function normalizeAppointmentUtc(value) {
  if (!value || typeof value !== 'string') return value;

  const trimmed = value.trim();
  if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?$/.test(trimmed)) {
    return `${trimmed.replace(' ', 'T')}Z`;
  }

  return trimmed;
}
